import { useEffect, useMemo } from 'react';

import { useProfesionales } from '@/features/profesionales/hooks/useProfesionales';

/**
 * Loads all profesionales and returns a map from uid_profesional → nombre_apellido.
 * Used by EstablecimientosTable to display the profesional name for each row.
 */
export function useProfesionalesMap() {
  const { items, isLoading, hasNextPage, fetchNextPage, isFetchingNextPage } =
    useProfesionales({
      sort_by: 'nombre_apellido',
      sort_order: 'asc',
      limit: 100,
    });

  useEffect(() => {
    if (hasNextPage && !isFetchingNextPage) {
      void fetchNextPage();
    }
  }, [hasNextPage, isFetchingNextPage, fetchNextPage]);

  const map = useMemo(() => {
    const m = new Map<string, string>();
    for (const p of items) {
      m.set(p.uid_profesional, p.nombre_apellido);
    }
    return m;
  }, [items]);

  return {
    getName: (uid: string): string => map.get(uid) ?? uid,
    isLoading: isLoading || hasNextPage,
  };
}
